import axios from 'axios';
import download from 'downloadjs';
import endpoints from '../../endpoints';
import {handleError, handleRawResponse, handleResponse} from "./apiUtils";


export function getOrder(orderId) {
    const url = endpoints.order(orderId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}
